export function redirection(link) {
    if (link) {
        if (window.top) {
            window.close();
            window.top.location.href = link;
        } else {
            window.location.href = link;
        }
    }
}